import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessagesService } from '../messages/messages.service';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable()
// Interceptor to inetrcept admin module requests and appends Bearer token
export class JwtInterceptor implements HttpInterceptor {

    
    
    constructor(private messagesService: MessagesService,private router: Router){        
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let currentUser
        if (localStorage.getItem('currentUser')) {
            currentUser = localStorage.getItem('currentUser');
        }

        if (currentUser) {
            request = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + currentUser)
            });
        }
        return next.handle(request).pipe(tap((response: HttpEvent<any>) => {
            if (response instanceof HttpResponse) {
              // do stuff with response if you want
            }
          }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                localStorage.removeItem('currentUser');
                console.log("API authentication failed(Interceptor): " + err.status);
                this.router.navigate(["/login"]);
              }
            }
          }));
    }

    
}